import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArrowRight, LogOut, Award, Calendar } from "lucide-react";
import { Logo } from "@/components/Brand";

export default function PortalHome() {
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-[#F9FAFB]">
      <header className="border-b border-gray-200 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <Logo />
          <button onClick={logout} data-testid="portal-logout" className="text-sm text-gray-600 hover:text-gray-900 flex items-center gap-1"><LogOut className="w-4 h-4" /> Sign out</button>
        </div>
      </header>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="fade-up">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-[#4F46E5] mb-3">Portal</div>
          <h1 className="font-display text-4xl tracking-tight font-semibold">Welcome, {user?.name}</h1>
          <p className="text-sm text-gray-500 mt-1">{user?.school_name}</p>
        </div>
        <div className="mt-10 grid sm:grid-cols-2 gap-4">
          <Link to="/book" data-testid="portal-book" className="group rounded-2xl border border-gray-200 bg-white p-6 hover:border-gray-300 hover:shadow-sm transition-all">
            <Calendar className="w-6 h-6 text-[#4F46E5]" />
            <h3 className="mt-4 font-display text-xl font-medium">Book a new training</h3>
            <p className="mt-1 text-sm text-gray-600">Choose a program, pick your date.</p>
            <div className="mt-4 text-sm font-medium text-[#4F46E5] flex items-center gap-1 group-hover:gap-2 transition-all">Go <ArrowRight className="w-4 h-4" /></div>
          </Link>
          <Link to="/verify" data-testid="portal-verify" className="group rounded-2xl border border-gray-200 bg-white p-6 hover:border-gray-300 hover:shadow-sm transition-all">
            <Award className="w-6 h-6 text-[#10B981]" />
            <h3 className="mt-4 font-display text-xl font-medium">Verify certificates</h3>
            <p className="mt-1 text-sm text-gray-600">Confirm any certificate issued to your teachers.</p>
            <div className="mt-4 text-sm font-medium text-[#4F46E5] flex items-center gap-1 group-hover:gap-2 transition-all">Go <ArrowRight className="w-4 h-4" /></div>
          </Link>
        </div>
      </main>
    </div>
  );
}
